import 'css-chunksrc/client/pages/projectPage/synthesisPage/reports/reportsList/report/indicatorsList/styles.scss';export default {
  "indicatorsList": "_indicatorsList_1061m_1",
  "input": "_input_1061m_7",
  "indicator": "_indicator_1061m_1",
  "name": "_name_1061m_24"
};